"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationResetOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.location-reset_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "location-reset_outline_svg__transparent_box" },
            React.createElement("path", { className: "location-reset_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "location-reset_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "location-reset_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M31 15h-3.06A12 12 0 0017 4.05V1h-2v3.05A12 12 0 004.05 15H1v2h3.05A12 12 0 0015 28v3h2v-3a12 12 0 0010.94-11H31zM16 26a10 10 0 1110-10 10 10 0 01-10 10z" }),
            React.createElement("path", { d: "M16 11a5 5 0 105 5 5 5 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z" }))));
}
exports.default = SvgLocationResetOutline;
//# sourceMappingURL=LocationResetOutline.js.map